// **************************
// CPE BALLOT
// **************************

export const getCpeBallotList = (language) => {
    switch (language) {
        case 'pt':
            return CPE_LIST
        break;
        case 'en':
            return EN_CPE_LIST;
        break;
        case 'es':
            return ES_CPE_LIST;
        break;
        case 'fr':
            return FR_CPE_LIST;
        break;
        default:
            break;
    }
}

export const getTranslatedCpeBallotOption = (value, language) => {
    switch (language) {
        case 'pt':
            for (let i = 0; i < CPE_LIST.length; i++) {
                if(CPE_LIST[i].code === value) {
                    return { code: value, name: CPE_LIST[i].name };
                }
            }
        break;
        case 'en':
            for (let j = 0; j < EN_CPE_LIST.length; j++) {
                if(EN_CPE_LIST[j].code === value) {
                    return { code: value, name: EN_CPE_LIST[j].name };
                }
            }
        break;
        case 'es':
            for (let j = 0; j < ES_CPE_LIST.length; j++) {
                if(ES_CPE_LIST[j].code === value) {
                    return { code: value, name: ES_CPE_LIST[j].name };
                }
            }
        break;
        case 'fr':
            for (let j = 0; j < FR_CPE_LIST.length; j++) {
                if(FR_CPE_LIST[j].code === value) {
                    return { code: value, name: FR_CPE_LIST[j].name };
                }
            }
        break;
        default:
            break;
    }
}

export const CPE_LIST = [
    { code: "Sim", name: "Sim" },
    { code: "Não", name: "Não" },
    { code: "Já foi solicitada", name: "Já foi solicitada" }
];

export const EN_CPE_LIST = [
    { code: "Sim", name: "Yes" },
    { code: "Não", name: "No" },
    { code: "Já foi solicitada", name: "Already requested" }
];

export const ES_CPE_LIST = [
    { code: "Sim", name: "Sí" },
    { code: "Não", name: "No" },
    { code: "Já foi solicitada", name: "Ya ha sido solicitada" }
];

export const FR_CPE_LIST = [
    { code: "Sim", name: "Oui" },
    { code: "Não", name: "Non" },
    { code: "Já foi solicitada", name: "Déjà demandé" }
];